import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';
import moment from 'moment';


let accessToken: string | undefined = '';
let expiresOn: moment.Moment;

export const getGlobalHeaders = async () => {
  // Check if the access token is stored in memory
  let token = localStorage.getItem('token');
  let exp = localStorage.getItem('exp');
  if (token) {
    // If the auth token or expiration is not set initialize the variables with the data stored in memory
    if (accessToken === '' || expiresOn === undefined) {
      accessToken = token;
      expiresOn = moment(exp);
    }

    // If the token is expired, refresh it
    // if (expiresOn.diff(moment.utc(), 'minutes') <= 0) {
    //   const response = await fetch('',{
    //     method: "POST",
    //     mode: "cors",
    //     headers: {
    //         "Content-Type": "application/json"
    //     },
    //     body: JSON.stringify
    //   })
    // }
  }

  let headers = [
    {
      Key: 'authorization',
      Value: `${accessToken}`
    },
  ];

  return headers;
};

export const buildUrl = (base: string, url: string) => {
  return `/${base}/${url}`
}
